import { Component, ElementRef, OnInit } from '@angular/core';

@Component({
  selector: 'app-message-manager',
  templateUrl: './message-manager.component.html',
  styleUrls: ['./message-manager.component.scss'],
})
export class MessageManagerComponent implements OnInit {
  index = 1;
  messages: string[] = [];

  get element(): HTMLElement {
    return this.elRef.nativeElement;
  }

  constructor(private elRef: ElementRef) {}

  ngOnInit(): void {}

  next(): void {
    if (this.index === this.messages.length) {
      this.index = 1;
    } else {
      this.index++;
    }
  }

  previous(): void {
    if (this.index === 1) {
      this.index = this.messages.length;
    } else {
      this.index--;
    }
  }

  empty(): void {
    this.messages.length = 0;
    this.index = 0;
  }
}
